var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsavingsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 28,
    viewBox: "0 0 33 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1111 27C25.1111 24.1301 21.2551 21.804 16.5 21.804C11.7449 21.804 7.88889 24.1301 7.88889 27M32 21.804C32 19.6737 29.8748 17.843 26.8333 17.0411M1 21.804C1 19.6737 3.12522 17.843 6.16667 17.0411M26.8333 10.0888C27.3436 9.63521 27.7596 9.08462 28.0575 8.46873C28.3554 7.85284 28.5292 7.18379 28.5691 6.50008C28.6089 5.81637 28.514 5.13148 28.2897 4.4848C28.0654 3.83812 27.7162 3.24241 27.2622 2.73193C26.8082 2.22146 26.2583 1.80628 25.6442 1.51029C25.03 1.2143 24.3638 1.04334 23.6837 1.00723C23.0036 0.971117 22.3231 1.07057 21.6814 1.29988C21.0397 1.52919 20.4494 1.88382 19.9444 2.34337M6.16667 10.0888C5.15451 9.16767 4.54599 7.88111 4.47401 6.5102C4.40204 5.13928 4.87247 3.79543 5.78254 2.7722C6.69261 1.74897 7.96835 1.12952 9.3311 1.04917C10.6938 0.968824 12.0328 1.4341 13.0556 2.34337M16.5 16.6081C15.1297 16.6081 13.8156 16.0606 12.8466 15.0862C11.8777 14.1118 11.3333 12.7901 11.3333 11.4121C11.3333 10.034 11.8777 8.71241 12.8466 7.73797C13.8156 6.76354 15.1297 6.21611 16.5 6.21611C17.8703 6.21611 19.1844 6.76354 20.1534 7.73797C21.1223 8.71241 21.6667 10.034 21.6667 11.4121C21.6667 12.7901 21.1223 14.1118 20.1534 15.0862C19.1844 16.0606 17.8703 16.6081 16.5 16.6081Z",
    stroke: "#FAF6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsavingsicon);
export default __webpack_public_path__ + "static/media/groupsavingsicon.db17c2bc7332cb582ef7f3769f0f066c.svg";
export { ForwardRef as ReactComponent };